module.exports = __webpack_public_path__ + "img/money.8543fe3f.png";